import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const ProfileRightBtnWrapperDefault: React.SFC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const ProfileRightBtnWrapper = styled(ProfileRightBtnWrapperDefault)`
    width: fit-content;
    margin-top: 40px;
    margin-bottom: 10px;
    margin-left: auto;
    
    display: flex;
`;

export default ProfileRightBtnWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/profile_right_btn_wrapper.tsx